export default __webpack_public_path__ + "static/media/resume.09682121.pdf";